import { tafMiddlewareManager } from "../helper";
import { timeMiddleware } from "./time";
import { userIdMiddleware } from "./userId";

export const initMiddlewareManager = () => {
  [timeMiddleware, userIdMiddleware].forEach(middleware => {
    tafMiddlewareManager.use(middleware);
  });
};
